"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useAsRef", {
    enumerable: true,
    get: function() {
        return useAsRef;
    }
});
const _react = require("react");
const useAsRef = (value)=>{
    const ref = (0, _react.useRef)(value);
    (0, _react.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
};

//# sourceMappingURL=useAsRef.js.map